const BurgerMenu = (props) => (
  <svg
    width={33}
    height={23}
    viewBox='0 0 33 23'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.166504 22.2583V20.2166H32.8332V22.2583H0.166504ZM0.166504 12.5211V10.4794H32.8332V12.5211H0.166504ZM0.166504 2.78385V0.742188H32.8332V2.78385H0.166504Z'
      fill='currentColor'
    />
  </svg>
);
export default BurgerMenu;
